import {useEffect} from 'react';
import {useNavigate} from "react-router-dom";

const ErrorPage = () => {
    /******Use for redirection if user hit this component******/
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/');
    });


}

export default ErrorPage;